module.exports = __webpack_public_path__ + "img/LogoutSmall.7b7c7643.svg";